import { Outlet } from 'react-router-dom';

function SimpleRootLayout() {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default SimpleRootLayout;